import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Button, Table, Pagination, Row, Col, Space } from 'antd'
import { CheckCircleOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { Loading, Page, Panel, Total } from '../../../../../components'
import { BreadcrumbSystem as Breadcrumb, SysPermission } from '../../../../../constants'
import { sysModuleService, orgModuleService } from '../../../../../services'
import { auth, validator } from '../../../../../util'
import { SysStore } from '../../../../../stores'

import 'antd/dist/antd.css'
import './styles.css'

const pageSize = 20

/** Rule: Must define breadcrumb in every page **/
const breadcrumb = [
  Breadcrumb.HomeBase,
  Breadcrumb.SystemBase,
  Breadcrumb.SystemModuleOrgList
]

const columns = [
  {
    title: 'Module Name',
    dataIndex: 'name',
    key: 'name',
    width: 8
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 11
  },
  {
    width: 3,
    render: (item) => <Space size='middle'>
      { hasAccess(SysPermission.PORTAL.SYS_ORG_MODULE_PMS.READ)
        ? <Link to={`/systems/modules-org/${item.id}`} key={`modulekey${item.id}`}>
          <FormOutlined />
        </Link>
        : null }

    </Space>
  },
]

const hasAccess = (permission) => {
  return auth.hasAccess(permission)
}

function SystemModuleList () {
  const [isLoading, setIsLoading] = useState(false)
  const [filter, setFilter] = useState({ active: true })
  const [sort, setSort] = useState({})

  useEffect(() => {
    fetchList({ currentPage: 1 })
  }, [])

  const list = SysStore.useState(e => e.sysModuleOrgList)
  const page = SysStore.useState(e => e.sysModuleOrgPage)
  const total = SysStore.useState(e => e.sysModuleOrgTotal)
  const isSysModuleOrgListLoading = SysStore.useState(e => e.isSysModuleOrgListLoading)

  async function fetchList ({ currentPage = page }) {
    if (!hasAccess(SysPermission.PORTAL.SYS_ORG_MODULE_PMS.LIST)) return

    setIsLoading(true)
    const r = await orgModuleService.listByPage(currentPage, pageSize, filter, sort)
    if (r && r.list) {
      setIsLoading(false)
      SysStore.update(e => {
        e.sysModuleOrgList = r.list
        e.sysModuleOrgTotal = r.total
        e.sysModuleOrgPage = currentPage
      })
    }
  }

  return (
    <Page.Body>
      <Page.Breadcrumb item={breadcrumb} />

      <Page.Header title='Modules & Permissions (Portal Organisation)'>
        { hasAccess(SysPermission.PORTAL.SYS_ORG_MODULE_PMS.CREATE)
          ? <Link to='/systems/modules-org/add'>
            <Button shape='round' type='primary'>Add Modules</Button>
          </Link>
          : null }

      </Page.Header>

      <Page.Content>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={list}
          size='small'
          rowKey={(itm) => (`lcors${itm.id}`)}
          pagination={{
            hideOnSinglePage: true,
            pageSize,
            total,
            onChange: (e) => fetchList({currentPage: e})
          }}
        />
        <Total total={total} title={'module'} />
      </Page.Content>
    </Page.Body>
  )
}

export default SystemModuleList
